module.exports = __webpack_public_path__ + "media/images/Info icone-319947b368871ec14d40e31f4af877a7.svg";